<div>
    <app-make-payment-tsp [billReference]="billRef()"></app-make-payment-tsp>


    <ng-container [ngTemplateOutlet]="confirmation_modal" *ngIf="openModal()"></ng-container>
</div>


<ng-template #confirmation_modal>
    <app-modal-v1 [disableOverlayClose]="true">
        <div [ngClass]="{'bg-white min-w-[600px] p-6': true}">
            <div [ngClass]="{
                        'h-[445px] max-h-[445px] overflow-auto flex flex-col': true
                      }">
                <div [ngClass]="{
                          'flex items-center w-full max-w-[438px] mx-auto': true
                        }">
                    <img [ngSrc]="'assets/images/primeguage_logo_payment_redirect_page.png'" alt="primeguage-logo"
                        priority width="62" height="52.5" [ngClass]="{ 'h-[52.5px] w-[62px]': true }" />
                    <div class="flex-1 h-[3px] bg-slate-300">
                        <div [ngClass]="{
                                'w-[0%] bg-[#178CA6] h-full': true,
                                progress_animate: !isSuccess(),
                                progress_complete: isSuccess()||isPaymentConfirmationError(),
                              }"></div>
                    </div>
                    <img [ngSrc]="providerImageSrc" alt="remita-logo" priority width="40" height="40"
                        [ngClass]="{ 'size-10': true }" />
                </div>
                @if (!isPaymentConfirmationError()) {
                <div>
                    <h4 [ngClass]="{
                                  'mt-6 text-center font-bold text-[20px] leading-[38px]': true
                                }" *ngIf="!isSuccess()">
                        Payment Confirmation Pending
                    </h4>
                    <h4 [ngClass]="{
                                  'mt-6 text-center font-bold text-[20px] leading-[38px]': true
                                }" *ngIf="isSuccess()">
                        Payment Confirmed
                    </h4>

                </div>
                <div [ngClass]="{ 'text-center text-[#717272] pt-5 flex-1': true }">
                    @if (!isSuccess()) {
                    <p>
                        We're waiting for payment confirmation.<br />
                        Thank you for your patience.
                    </p>

                    }@else {
                    <div [ngClass]="{ 'flex flex-col gap-5 items-center': true }">
                        <div [ngClass]="{ '': true }">
                            <p>Thank you for your patience.</p>

                            <p>You will be redirected shortly.</p>
                        </div>
                        <div>
                            <nz-progress [nzPercent]="progressPercent$ | async" nzType="circle" [nzFormat]="formatOne"
                                [nzStrokeColor]="{ '0%': '#178CA6', '100%': '#178CA6' }" [nzWidth]="100"></nz-progress>
                        </div>
                    </div>
                    }
                </div>

                }@else {
                <div [ngClass]="{'flex flex-col flex-1': true}">
                    <h4 [ngClass]="{'mt-6 text-center font-bold text-[20px] leading-[38px]': true}">
                        Payment Confirmation Failed
                    </h4>
                    <h4 [ngClass]="{'mt-6 text-center  text-base': true}">
                        We are unable to confirm payment at this time. This might be due to issues with the payment
                        providers. Kindly check on your dashboard periodically for confirmation.<br />
                        Thank you.
                    </h4>


                    <div [ngClass]="{'mb-6 mt-auto flex justify-center': true}">
                        <a [routerLink]="routeLink" [ngClass]="{
                                                                          ' py-3 font-semibold text-white rounded-lg shadow bg-tw-primary text-base !w-[unset] !px-6 !normal-case': true,
                                                                        }">
                            Return to
                            Dashboard</a>
                    </div>

                </div>
                }

            </div>
        </div>
    </app-modal-v1>
</ng-template>
